import type { SVGProps } from 'react'
import type { Locale } from '@hub/contracts'

/** Small rounded flag glyphs for the language switch (inline SVG — no emoji, so they render on every OS). */
export function SwedishFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 12" aria-hidden {...props}>
      <rect width="16" height="12" rx="1.5" fill="#006AA7" />
      <rect x="5" width="2.5" height="12" fill="#FECC02" />
      <rect y="4.75" width="16" height="2.5" fill="#FECC02" />
    </svg>
  )
}

export function UsFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 12" aria-hidden {...props}>
      <defs>
        <clipPath id="us-flag-clip">
          <rect width="16" height="12" rx="1.5" />
        </clipPath>
      </defs>
      <g clipPath="url(#us-flag-clip)">
        <rect width="16" height="12" fill="#fff" />
        {[0, 2, 4, 6, 8, 10].map((y) => (
          <rect key={y} y={y} width="16" height="1" fill="#B22234" />
        ))}
        <rect width="7" height="6" fill="#3C3B6E" />
        {[1, 3, 5].flatMap((x) =>
          [1, 3, 5].map((y) => (
            <circle key={`${x}-${y}`} cx={x + 0.5} cy={y - 0.2} r="0.45" fill="#fff" />
          ))
        )}
      </g>
    </svg>
  )
}

export function LocaleFlag({ locale, ...props }: { locale: Locale } & SVGProps<SVGSVGElement>) {
  return locale === 'en' ? <UsFlag {...props} /> : <SwedishFlag {...props} />
}
